module.exports = __webpack_public_path__ + "static/media/courses.c162c38e.png";